export const formatMetricForecastPeriod = (
  period: string | null | undefined,
  includeYear = true
) => {
  if (!period) {
    return null;
  }

  const quarterMatch = /^(\d{4})Q([1-4])$/.exec(period.trim());
  if (quarterMatch) {
    return `Q${quarterMatch[2]}${includeYear ? ` ${quarterMatch[1].slice(-2)}` : ''}`;
  }

  const eoyMatch = /^(\d{4})EOY$/.exec(period.trim());
  if (eoyMatch) {
    return `EOY${includeYear ? ` ${eoyMatch[1].slice(-2)}` : ''}`;
  }

  return period;
};
